<template>
  <b-card>
    <b-row>
      <b-col sm="12" md="7">
        <h5 class="mc-general__label">{{ $t('report.object.totalRitage') }}</h5>
      </b-col>
      <b-col sm="12" md="5" class="mc-row-check-wrapper right-items mb-2">
        <b-button-group>
          <McButton
            :variant="isTable ? 'primary' : 'secondary'"
            icon="icon-outline_browser"
            text="Table"
            @click="changeTable(true)"
          />
          <McButton
            :variant="isTable ? 'secondary' : 'primary'"
            icon="icon-fill_activity"
            :text="$t('delivery.text.chart')"
            @click="changeTable(false)"
          />
        </b-button-group>
      </b-col>
    </b-row>
    <b-skeleton-wrapper :loading="dataChart.isLoadingGraph ?? true">
      <template #loading>
        <b-skeleton-img no-aspect height="400px" />
      </template>
      <BarChart
        v-if="!dataChart.isLoadingGraph && !isTable"
        :labels="dataChart.chartData?.labels ?? []"
        :datasets="dataChart.chartData?.datasets ?? []"
        :yLabel="$t('report.object.totalRitage')"
        :key="chartKey"
      />
      <b-table
        v-if="!dataChart.isLoadingGraph && isTable"
        show-empty
        :empty-text="$t('global.emptyTable')"
        :fields="fields"
        :items="dataList"
        class="datatables my-3 border border-1"
        responsive="sm"
        empty-table
        :per-page="perPage"
        :current-page="currentPage"
      >
      </b-table>
    </b-skeleton-wrapper>
  </b-card>
</template>
<style>
.right-items {
  text-align: right;
}
</style>
<script>
import McButton from '@/components/McButton'
import BarChart from '@/components/Chart/Bar'
export default {
  components: {
    McButton,
    BarChart,
  },
  data() {
    return {
      isTable: false,
      yAxesAdditional: {
        display: false,
      },
      perPage: 10,
      currentPage: 1,
      chartKey: 0,
    }
  },
  watch: {
    dataChart: {
      handler() {
        this.chartKey += 1
      },
      deep: true,
    },
  },
  computed: {
    dataChart() {
      return this.$store.state.report.summaryRitageReport.chart
    },
    dataList() {
      return this.$store.state.report.summaryRitageReport.list
    },
    fields() {
      return [
        {
          key: 'date',
          label: this.$t('report.fields.date'),
        },
        {
          key: 'totalRitage',
          label: this.$t('report.object.totalRitage'),
        },
      ]
    },
  },
  methods: {
    changeTable(isTable) {
      this.isTable = isTable
    },
  },
}
</script>
